import util from 'util';
import { CONSTANT } from '@const';
import { MCCSummaryItem } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class MeterCaseService extends ApiService {
	protected static baseUrl = CONSTANT.DQP_API_BASE_URL;

	static async getMeterCase(meterCaseCode: string): Promise<MCCSummaryItem> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(`${CONSTANT.DQP_METER_CASE_CODE_API_URL}`, meterCaseCode),
		};
		return await this.executeApiRequest(params);
	}
}
